<template>
  <section>
    <div class="d-flex align-items-center justify-content-between mb-3">
      <div class="d-flex align-items-center">
        <h1 class="title mr-3">{{ $t('src/pages/hospitals.915') }}</h1>
        <router-link :to="{ name: 'hospital-add' }" class="btn btn-primary btn-with-icon" data-testid="btn-add-hospital">
          <span class="icon icon-plus"></span>{{ $t('src/pages/hospitals.7214') }}</router-link
        >
      </div>
      <div style="width: 305px">
        <input
          type="text"
          class="form-control"
          :value="currentTitle"
          @input="inputTitle"
          :placeholder="currentTitle ? currentTitle : $t('src/pages/hospitals.inputTitle')"
        />
      </div>
    </div>

    <base-table
      data-testid="table-hospitals"
      :no-data="!hasHospitals"
      :headers="headers"
      :loading="loading"
      :sorting="sorting"
      @sorting="changeSorting"
    >
      <template #tbody>
        <hospital-table-row
          v-for="hospital in hospitals"
          :key="hospital.id"
          :hospital="hospital"
          :data-testid="`hospital-row-${hospital.id}`"
          @delete="deleteHospital"
        ></hospital-table-row>
      </template>
    </base-table>

    <div class="mt-3">
      <paginator
        v-if="showPaginator"
        :total="totalCount"
        :per-page="perPage"
        v-model="currentPage"
        @change:count="numberOfElements"
      ></paginator>
    </div>
  </section>
</template>

<script>
import http from '@/modules/http.js'
import { paginator } from '@/mixins/paginator.js'
import { stringify } from 'qs'
import debounce from 'debounce'

export default {
  name: 'HospitalsList',
  mixins: [paginator],
  components: {
    HospitalTableRow: () => import('@/components/table-rows/HospitalTableRow.vue'),
    BaseTable: () => import('@/base/BaseTable.vue')
  },
  data: () => ({
    hospitals: null,
    loading: true,
    sorting: {
      by: 'title',
      order: 'asc'
    },
    currentTitle: null
  }),
  computed: {
    sortParams() {
      const sortOrder = this.sorting.order === 'asc' ? 1 : -1
      if (this.sorting.by === 'title') {
        return {
          title: sortOrder
        }
      }
      return {
        id: sortOrder
      }
    },

    params() {
      let params = Object.assign({}, this.pageParams)

      params['$sort'] = this.sortParams

      if (this.currentTitle) {
        params['title'] = {
          $like: `%${this.currentTitle}%`
        }
      }
      return params
    },
    headers() {
      return {
        title: {
          title: this.$t('src/pages/hospitals.name'),
          sortable: true,
          sorting: 'asc'
        },
        admins: {
          title: this.$t('src/pages/hospitals.institutionalAdministrators')
        },
        systemPeriod: {
          title: `${this.$t('systemAccess.systemUsagePeriod')}`,
          class: 'th-empty'
        }
      }
    },
    hasHospitals() {
      return this.hospitals && this.hospitals.length > 0
    }
  },
  created() {
    this.inputTitle = debounce(this.inputTitle, 500)
  },
  mounted() {
    if (this.$store.getters.IS_SELECTED_HOSPITAL) {
      this.$store.dispatch('RESET_HOSPITAL')
    }
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true

      http
        .get('/hospitals', {
          params: this.params,
          paramsSerializer: params =>
            stringify(params, {
              arrayFormat: 'indices',
              encodeValuesOnly: true
            })
        })
        .then(response => response.data)
        .then(data => {
          this.totalCount = data.total
          this.hospitals = data.data
        })
        .catch(error => console.error(error))
        .finally(() => (this.loading = false))
    },
    deleteHospital(id) {
      http
        .delete('/hospitals/' + id)
        .then(() => {
          this.hospitals = this.hospitals.filter(hospital => hospital.id !== id)
        })
        .catch(error => {
          console.error(error)
        })
    },
    numberOfElements(number) {
      this.perPage = number
    },
    changeSorting(sortingData) {
      this.sorting = sortingData
      this.loadData()
    },
    inputTitle(e) {
      this.currentTitle = e.target.value
      this.loadData()
    }
  }
}
</script>
